<template>
  <div class="privacy-container">
    <h1>隐私政策</h1>

    <div class="content">
      <p>
        欢迎使用“猫小悟”（以下简称“本应用”）。我们非常重视您的个人信息和隐私保护。
        本隐私政策将说明我们如何收集、使用和保护您的信息。
        <br />
        最近更新日期：2026年8月8日
      </p>

      <h3>一、我们收集的信息</h3>

      <p>
        在您使用本应用过程中，我们可能会收集以下信息：
      </p>

      <p>
        1. <b>账号信息</b><br />
        当您使用手机号登录时，我们会收集您的手机号，用于账号注册与登录验证。
      </p>

      <p>
        2. <b>用户内容</b><br />
        当您使用评论、发布书单等功能时，我们会收集您主动发布的内容（如文字、图片等），用于展示和互动功能。
      </p>

      <p>
        3. <b>设备与日志信息</b><br />
        为保障应用正常运行及优化体验，我们可能收集设备型号、操作系统版本、IP地址、操作日志等信息。
      </p>

      <p>
        4. <b>统计分析信息</b><br />
        我们会使用埋点统计技术分析应用使用情况（如页面访问、点击行为），用于改进产品体验。
      </p>

      <h3>二、我们如何使用信息</h3>

      <p>
        我们收集的信息将用于：
      </p>

      <p>
        - 提供账号登录与身份验证<br />
        - 支持评论、发布书单等功能<br />
        - 优化产品体验与性能<br />
        - 防止异常行为及保障安全
      </p>

      <h3>三、信息共享与第三方服务</h3>

      <p>
        我们不会将您的个人信息出售给任何第三方。
      </p>

      <p>
        在以下情况下，我们可能会共享必要信息：
      </p>

      <p>
        1. 为实现统计分析功能，我们可能接入第三方统计服务（如 Firebase 等）。<br />
        2. 为提供商品推广服务，我们集成了京东联盟广告SDK。该SDK可能会收集您的设备信息（如OAID、IDFA）、网络状态等，用于广告投放、监测及效果分析。详细情况请参阅《京东联盟广告SDK隐私政策》。<br />
        3. 为保障应用质量与稳定性，我们集成了腾讯Bugly SDK，用于崩溃监控、错误上报及应用性能分析。该SDK可能会收集设备标识信息（如Android ID、ICCID）、设备型号、操作系统版本及运行中的进程信息等。详细情况请参阅《腾讯Bugly SDK个人信息保护规则》。<br />
        4. 法律法规要求或监管部门要求时。
      </p>

      <p>
        我们会确保第三方仅在必要范围内使用信息。
      </p>

      <h3>四、信息存储与安全</h3>

      <p>
        我们会采取合理的技术措施保护您的信息安全，防止未经授权访问、泄露或篡改。
      </p>

      <p>
        您的信息将在实现本政策目的所需的最短时间内保存。
      </p>

      <h3>五、您的权利</h3>

      <p>
        您有权：
      </p>

      <p>
        - 查询、更正您的信息<br />
        - 删除您的账号及相关数据<br />
        - 撤回授权
      </p>

      <h3>六、账号注销</h3>

      <p>
        您可以通过应用内功能或联系我们申请注销账号。
        注销后，我们将删除或匿名化您的相关信息（法律另有规定除外）。
      </p>

      <h3>七、儿童保护</h3>

      <p>
        本应用主要面向成年人。如您为未成年人，请在监护人指导下使用。
      </p>

      <h3>八、政策更新</h3>

      <p>
        我们可能会不定期更新本政策，更新后将在应用内公布。
      </p>

      <h3>九、第三方SDK目录</h3>

      <p>
        为保障本应用相关功能的实现与稳定运行，我们可能会接入由第三方提供的软件开发包（SDK）。我们会对合作方获取信息的软件工具开发包进行严格的安全检测，以保护您的数据安全。以下是我们的第三方SDK合作伙伴列表：
      </p>

      <div style="overflow-x: auto; margin: 15px 0;">
        <table style="width: 100%; border-collapse: collapse; font-size: 12px; border: 1px solid #ddd;">
          <thead>
            <tr style="background-color: #f5f5f5;">
              <th style="padding: 10px; border: 1px solid #ddd; text-align: left;">SDK名称</th>
              <th style="padding: 10px; border: 1px solid #ddd; text-align: left;">第三方公司</th>
              <th style="padding: 10px; border: 1px solid #ddd; text-align: left;">使用目的</th>
              <th style="padding: 10px; border: 1px solid #ddd; text-align: left;">收集的个人信息类型</th>
              <th style="padding: 10px; border: 1px solid #ddd; text-align: left;">隐私政策链接</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd;">京东联盟广告SDK</td>
              <td style="padding: 10px; border: 1px solid #ddd;">北京京东叁佰陆拾度电子商务有限公司</td>
              <td style="padding: 10px; border: 1px solid #ddd;">广告投放、监测及效果分析，提供商品推广服务</td>
              <td style="padding: 10px; border: 1px solid #ddd;">设备信息（OAID、IDFA、操作系统版本等）、网络状态信息、应用信息</td>
              <td style="padding: 10px; border: 1px solid #ddd;">
                <a href="https://union.jd.com/searchResultDetail?articleId=177725" target="_blank" rel="noopener noreferrer" style="word-break: break-all; color: #0066cc;">
                  查看隐私政策
                </a>
              </td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd;">腾讯Bugly SDK</td>
              <td style="padding: 10px; border: 1px solid #ddd;">深圳市腾讯计算机系统有限公司</td>
              <td style="padding: 10px; border: 1px solid #ddd;">应用崩溃监控、错误上报及性能分析，便于开发者快速发现并修复线上问题</td>
              <td style="padding: 10px; border: 1px solid #ddd;">设备标识信息（Android ID、ICCID）、设备型号、操作系统版本、运行中的进程信息</td>
              <td style="padding: 10px; border: 1px solid #ddd;">
                <a href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56" target="_blank" rel="noopener noreferrer" style="word-break: break-all; color: #0066cc;">
                  查看隐私政策
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h3>十、联系我们</h3>

      <p>
        如您对本隐私政策有任何疑问，请通过以下方式联系我们：
      </p>

      <p>
        邮箱：1353966998@qq.com
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style scoped>
.privacy-container {
  padding: 20px;
  background: #fff;
  max-width: 800px;
  margin: 0 auto;
}

h1 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 24px;
  color: #333;
}

.content {
  text-align: left;
  line-height: 1.8;
  font-size: 14px;
  color: #333;
}

h3 {
  margin-top: 25px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

p {
  margin-bottom: 12px;
}

b {
  font-weight: bold;
}

/* 表格响应式优化 */
@media (max-width: 600px) {
  .privacy-container {
    padding: 15px;
  }

  table {
    font-size: 11px;
  }

  td, th {
    padding: 8px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/module/privacy/Privacy.vue